// Route → module map. Only safe metadata (module name) is sent to the assistant.
const MAP = [
  ["/dashboard/news-center", "AI News & Content Center"],
  ["/dashboard/news-studio", "News Studio"],
  ["/dashboard/music-news", "AI Music News"],
  ["/dashboard/dj", "AI DJ Assistant"],
  ["/dashboard/imaging", "Imaging Studio"],
  ["/dashboard/commercials", "Commercial Creator"],
  ["/dashboard/quick-promo", "Quick Promo"],
  ["/dashboard/podcasts", "Podcast Creator"],
  ["/dashboard/production-suite", "Production Suite"],
  ["/dashboard/voice-studio", "Voice Studio"],
  ["/dashboard/vision-studio", "Vision Studio"],
  ["/dashboard/social", "Social Publishing"],
  ["/dashboard/nowplaying", "Now Playing"],
  ["/dashboard/rss", "RSS Feeds"],
  ["/dashboard/blog-connector", "Blog Connector"],
  ["/dashboard/magazine", "Digital Magazine"],
  ["/dashboard/engagement", "Audience Engagement Hub"],
  ["/dashboard/listener-voice", "Listener Voice Inbox"],
  ["/dashboard/academy", "Academy"],
  ["/dashboard/help", "Help Center"],
  ["/dashboard/billing", "Billing"],
  ["/dashboard/language-center", "Language Center"],
  ["/dashboard/team", "Team"],
  ["/dashboard/account", "Account"],
];

export function moduleForPath(pathname) {
  const hit = MAP.find(([prefix]) => pathname.startsWith(prefix));
  return hit ? hit[1] : pathname === "/dashboard" ? "Control Room" : "";
}
